import React from 'react';
import { Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

const TextInformation = ({ name, props }) => {
    let text;
    if (props.staticValue) {
        text = props.staticValue;
    } else {
        const { getValues } = useFormContext();
        text = getValues(name) ?? props.staticValue;
    }

    return (
        <Typography {...props}>
            {props.label}: {text}
        </Typography>
    );
};

export default TextInformation;
